import { Spacer } from "../../components/core/utility";
import React, { useState, lazy } from "react";
import { Tabs, Tab } from "@vds/tabs";
import { handleAddPage } from "../C4S Decommission - Replacement/utils";
import { OrderShippingSummaryAccordion } from "../C4S Decommission - Replacement/OrderShippingSummaryAccordion";
import SelectionMaterial from "./SelectionMaterial";
import ReturnedMaterial from "./ReturnedMaterial";
import { AssignMaterialComponentMetadata } from "./AssignMaterialComponent";
import ConfirmationModal from "./ConfirmationModal";

export default function ReturnReship(props) {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [isConfirmationModal, setIsConfirmationModal] = useState(false);
  const [actionName, setActionName] = useState("");
  const [selectedMaterials, setSelectedMaterials] = useState([]);

  const onTabChange = (index) => {
    setSelectedTabIndex(index);
  };

  const openAssignMaterialPage = (data, actionName) => {
    handleAddPage(AssignMaterialComponentMetadata.id, {
      selectedMaterials,
      actionName,
    });
  };

  const onReturnOrReshipAction = (value, data) => {
    setIsConfirmationModal(true);
    setActionName(value);
    setSelectedMaterials(data);
  };

  const handleContinue = (data) => {
    setIsConfirmationModal(false);
    openAssignMaterialPage(data, actionName);
    return;
  };

  return (
    <>
      <Spacer bottom="1rem" />
      <OrderShippingSummaryAccordion />
      <div css={{ width: "9.5rem" }}>
        <Tabs
          role="tablist"
          orientation="horizontal"
          indicatorPosition="bottom"
          width="auto"
          onTabChange={(e, index) => {
            onTabChange(index);
          }}
          selectedIndex={selectedTabIndex}
        >
          <Tab role="tab" key={0} label="Selection" aria-label="Selection" />
          <Tab role="tab" key={1} label="Returned" aria-label="Returned" />
        </Tabs>
        <Spacer top="0.5rem" />
      </div>
      {selectedTabIndex === 0 && <SelectionMaterial data={props} onReturnOrReshipAction={onReturnOrReshipAction} />}
      {selectedTabIndex === 1 && <ReturnedMaterial data={props} />}
      {isConfirmationModal && (
        <ConfirmationModal
          isConfirmationModal={isConfirmationModal}
          setIsConfirmationModal={setIsConfirmationModal}
          handleContinue={handleContinue}
          modalHeading="Confirmation"
          modalBody="Are you sure you want to return or return and reship for the selected materials?"
          actionName={actionName}
        />
      )}
    </>
  );
}

export const ReturnReshipMetadata = {
  name: "Return Reship",
  id: "return_reship",
  component: lazy(() => import("./ReturnReship")),
  route: "/return_reship",
  breadcrumbs: false,
};
